import getMetricsData from '@api/metricContainer';
import { get } from 'lodash';
import instance from '@api/axiosInstance';
import {
  getInvertedPercentageMetricByKey,
  getPercentageMetricByKey,
} from '@src/utils/metrics/metricHelpers';
import { createQuery } from '@src/components/widget-panel/utils/query';
import useQueryParams from '../../hooks/useQueryParams';
import { useMemo } from 'react';
import useWidgetQuery from '../../hooks/useWidgetQuery';

function useFetchMetrics({ wid, metrics = [], granularity, tag = 'viewers', enabled }) {
  const { interval, filter, _rKey, allowedMetrics, liveMode } = useQueryParams();

  // TODO: refactor as util
  const allowedMetricList = useMemo(() => {
    const filteredMetrics = metrics.filter(
      (metric) =>
        metric in allowedMetrics ||
        getInvertedPercentageMetricByKey({ metricKey: metric }) in allowedMetrics,
    );
    let queryMetrics = [...filteredMetrics];

    queryMetrics.forEach((m) => {
      const invertedMetric = getPercentageMetricByKey({ metricKey: m, defaultValue: null });
      if (invertedMetric) {
        queryMetrics.push(invertedMetric);
      }
    });

    queryMetrics = [...new Set(queryMetrics)].sort();

    return queryMetrics;
  }, [metrics, allowedMetrics]);

  const options = { withTotals: false };

  const payload = createQuery(
    allowedMetricList,
    `${interval.from}/${interval.to}`,
    granularity,
    filter,
    options,
  );

  return useWidgetQuery({
    wid,
    queryKey: ['widget', tag, payload.queries, _rKey],
    queryFn: () =>
      getMetricsData(payload, {}, instance).then((response) => {
        const { data, totals, annotations } = get(response, ['data', '0'], {
          totals: {},
          data: [],
          annotations: [],
        });
        return { data, totals };
      }),
    options: {
      retry: false,
      refetchOnWindowFocus: false,
      enabled: enabled && !!metrics.length && !liveMode,
      staleTime: 5 * 60 * 1000, // 5m
    },
  });
}

export default useFetchMetrics;
